<template>
  <div>
    <EvaluationHeaderBar></EvaluationHeaderBar>
    <div class="container">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>
<script>
import { getProjectInfo } from "@/api/project";
import EvaluationHeaderBar from "../components/EvaluationHeaderBar.vue";
export default {
  data() {
    return {};
  },
  mounted() {this.getProjectInfo()},
  methods: {
    getProjectInfo() {
      let project_id = this.$route.params.id;
      getProjectInfo(project_id).then((res) =>{
        this.$store.commit("SET_SURVEY_BODY", { title: res.data.name });
      });
    },
  },
  components: { EvaluationHeaderBar },
  props: {},
};
</script>
<style lang="less" scoped>
.container {
}
</style>